import React from "react";
import { motion } from "framer-motion";

// Pastikan Anda memiliki gambar yang sesuai untuk Teaching Experience
import introImg from "../../images/teaching_experience/te_intro.png"; 

const HelloTeachingExperience = () => {
  const gotoNext = () => {
    // Arahkan ke kuesioner pertama Teaching Experience
    window.location.href = "/teaching-experience/exp1"; 
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 text-white relative overflow-hidden px-4">

      {/* TITLE */}
      <h1 className="text-2xl md:text-3xl font-extrabold text-yellow-300 mt-10 text-center drop-shadow-md">
        Now Let’s Assess Your Teaching Experience
      </h1>

      {/* MAIN CONTENT */}
      <div className="relative mt-10 flex flex-col md:flex-row items-center md:items-start justify-center gap-5">

        {/* IMAGE */}
        <img
          src={introImg}
          alt="teacher"
          className="w-[220px] md:w-[300px] drop-shadow-xl"
        />

        {/* TEXT WITHOUT BUBBLE */}
        <div
          className="
            text-left text-white
            text-base md:text-xl font-medium 
            leading-relaxed max-w-sm
            md:mt-6              
            md:ml-[-10px]        
          "
        >
          Read each statement and select <br />the option
          that best describes your experience
          and current practice in teaching.
        </div>
      </div>

      {/* BUTTON */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={gotoNext}
        className="mt-10 bg-yellow-300 text-blue-900 font-semibold px-10 py-3 rounded-full shadow-lg"
      >
        Start Assessment →
      </motion.button>

      {/* FOOTER */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default HelloTeachingExperience;